// @ts-nocheck
import React, { useRef, useState } from 'react';
import { toast } from 'react-toastify';
import * as action from '../Action/Verify_Email/Verify_Email_Action';
import * as sendCodeAction from '../Action/Send_Code/Send_Code_Action';
import { useAppDispatch } from '../hooks';
import LoginLayout from './LoginLayout';

const UNIVERSITY_URL = 'https://avsight.northpass.com/app';

const Email = ({ setIsEmailSubmit, setData, setEmail, email, requestHelpData, setRequestHelpData }) => {
  const dispatch = useAppDispatch();
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const emailRefFocus = useRef();

  const verifyEmail = async (e) => {
    e.preventDefault();
    if (submitting) return;
    setErrors({});
    let customErrors = {};
    if (email === '') {
      customErrors = { ...customErrors, email: 'Please enter your email to continue.' };
      emailRefFocus.current.focus();
    }

    if (email && email.includes('+')) {
      toast.error('Sorry, email plus-addressing is not supported');
      return;
    }

    if (Object.keys(customErrors).length > 0) {
      setErrors(customErrors);
      return true;
    }
    setSubmitting(true);
    const param = { email: email };
    dispatch(action.verifyEmail({ data: JSON.stringify(param) }))
      .then((response) => {
        if (response.status !== 1) {
          toast.error(response.message || 'Failed to verify email. Please try again.');
          setSubmitting(false);
          return;
        }
        if (response.message) {
          toast.success(response.message);
          setSubmitting(false);
          return;
        }
        if (response.data && response.data.portalEng && !response.data.portalEng.seniority) {
          response.data.contact.name = response.data.contact.name || '';
          response.data.contact.companyName = response.data.contact.companyName || '';
          response.data.contact.phone = response.data.contact.phone || '';
          setData(response.data);
          setIsEmailSubmit('preferences');
          return;
        }
        // Match the original behavior: fire sendCode and immediately transition to
        // the Verify screen (which unmounts this component); any sendCode failure
        // surfaces as a background toast just like before.
        sendCode();
        setIsEmailSubmit('verify');
      })
      .catch((error) => {
        console.log(error);
        toast.error(error.message || 'An error occurred during email verification. Please try again.');
        setSubmitting(false);
      });
  };

  const sendCode = () => {
    const param = { email: email };
    dispatch(sendCodeAction.sendCode({ data: JSON.stringify(param) }))
      .then((response) => {
        if (response.status !== 1) {
          toast.error(response.message || 'Failed to send verification code. Please try again.');
          return;
        }
        setIsEmailSubmit('verify');
      })
      .catch((error) => {
        console.log(error);
        toast.error(error.message || 'An error occurred while sending the verification code. Please try again.');
      });
  };

  const showNeedHelpModal = () => {
    setRequestHelpData({ ...requestHelpData, email: email, showNeedHelpModal: true });
  };

  return (
    <LoginLayout>
      <div className="login-form-card">
        <div className="login-form-card__accent" aria-hidden />
        <div className="login-form-card__body">
          <div className="login-form-brand text-center">
            <h1 className="login-form-title">Sign in</h1>
            <p className="login-form-lead text-muted">
              Enter your work email. New users get access to voting, knowledge search, and release notes. Returning users
              receive a PIN.
            </p>
          </div>

          <form className="login-form" onSubmit={verifyEmail} noValidate>
            <label className="form-label login-form-label" htmlFor="login-email">
              Work email
            </label>
            <div className="input-group login-form-input-group mb-2">
              <span className="input-group-text login-form-input-icon" id="login-email-addon">
                <i className="fa-solid fa-envelope" aria-hidden />
              </span>
              <input
                id="login-email"
                className={`form-control login-form-control ${errors?.email ? 'is-invalid' : ''}`}
                ref={emailRefFocus}
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                maxLength="255"
                autoComplete="email"
                placeholder="you@company.com"
                aria-describedby="login-email-addon"
                disabled={submitting}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    if (submitting) return;
                    verifyEmail(e);
                  }
                }}
              />
            </div>
            {errors?.email && <div className="invalid-feedback d-block mb-3">{errors.email}</div>}

            <button
              type="submit"
              className="btn btn-primary w-100 login-form-submit mb-3"
              disabled={submitting}
              aria-busy={submitting}
            >
              Continue
              <i
                className={submitting ? 'fa-solid fa-spinner fa-spin ms-2' : 'fa-solid fa-arrow-right ms-2'}
                aria-hidden
              />
            </button>

            <div className="text-center">
              <button
                type="button"
                className="btn btn-link btn-sm text-decoration-none login-form-help"
                onClick={() => showNeedHelpModal()}
              >
                <i className="fa-solid fa-circle-question me-1" aria-hidden />
                Need help signing in?
              </button>
            </div>
          </form>

          <div className="login-form-meta text-center">
            <span className="login-form-meta-label text-muted small">Additional resource</span>
            <a className="login-form-meta-link" href={UNIVERSITY_URL} rel="noopener noreferrer" target="_blank">
              <i className="fa-solid fa-graduation-cap me-1" aria-hidden />
              AvSight University
            </a>
          </div>
        </div>
      </div>
    </LoginLayout>
  );
};

export default Email;
